import { styled } from '@innowise-group/mui-kit';

export const OptionWrapper = styled.span``;
export const Location = styled.span`
  color: ${({ theme }) => theme.palette.general.darkGrey[40]};
`;
export const CurrentLocation = styled.span``;
